/* eslint-disable no-restricted-syntax */
import moment from '@shared/util/moment';

export function getTimezone() {
  return moment.tz.guess(true);
}
